module.exports = __webpack_public_path__ + "static/media/spicy.a50bd13d.png";